import { __ } from './utils';


export default ({ product, onSave = null, onClose = null }) => {
	
	const footnotes = __('Vous pourrez configurer les adresses de livraison et de facturation par la suite.') +  ' ' +
		__('Livraison&nbsp;:&nbsp;<strong>7,99€/mois</strong> ou gratuite si retrait en magasin.');
	
	return (
		<div className="box-configuration--summary">
			<Price amount={ product.price } />

			<div className="bcs--button">
				<button className="s2--button large" type="button" onClick={ event => onSave && onSave(event) }>{ __('Ajouter au panier') }</button>
				<div className="bcs--info box-form-info">
					<p dangerouslySetInnerHTML={{ __html: footnotes }}></p>
				</div>
				
				<div className="bcs--info box-form-modify">
					<button className="no-ui" type="button" onClick={ event => onClose && onClose(event) }>
						<svg className="icon-angle-left"><use xlinkHref="/cavedessommeliers/assets/img/icons.svg?106#icon-angle-left"></use></svg>
						{ __("Modifier l'abonnement") }
					</button>
				</div>
			</div>
		</div>
	)
}



export const Price = ({ amount }) => {
	return (
		<div className="bcs--price">
			<div className="bcs--price-title">{ __('total :') }</div>
			<div className="bcs--price-amount-info">
				<div className="price">{ accounting.formatMoney( amount ) }</div>
				<div className="info">{ __('Hors-livraison') }</div>
			</div>
		</div>
	);
}